module.exports = __webpack_public_path__ + "img/orange-cat.962d8430.png";